import { Component, ViewChild } from '@angular/core';
import { NavController, Slides } from 'ionic-angular';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

    public images: any;
	@ViewChild('slider') slider: Slides;

	page = 0;
	constructor(public navCtrl: NavController) {

	}

	ionViewWillEnter() {
		// this.countdown();
	}

	selectedTab(index) {
		this.slider.slideTo(index);
	}

	countdown() {
		CountDownTimer('2020-06-5 11:53:09', 'countdown');
		CountDownTimer('06/10/2020 3:0 PM', 'newcountdown');

		function CountDownTimer(dt, id) {
            
			var end: any = new Date(dt);

			var _second = 1000;
			var _minute = _second * 60;
			var _hour = _minute * 60;
			var _day = _hour * 24;
			var timer;

			function showRemaining() {
				var now: any = new Date();
				var distance = end - now;
				if (distance < 0) {

					clearInterval(timer);
					document.getElementById(id).innerHTML = '만료';

					return;
				}
				var days = Math.floor(distance / _day);
				var hours = Math.floor((distance % _day) / _hour);
				var minutes = Math.floor((distance % _hour) / _minute);
				var seconds = Math.floor((distance % _minute) / _second);

				document.getElementById(id).innerHTML = days + '일 ';
				document.getElementById(id).innerHTML += hours + '시 ';
				document.getElementById(id).innerHTML += minutes + '분 ';
				document.getElementById(id).innerHTML += seconds + '초';
			}

			timer = setInterval(showRemaining, 1000);
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts